import type { RatewareXLBaseDetailData } from "../../../hooks/react-query/backOffice/pricingAndRating/useRatewareXLBaseDetail";

const RATEWARE_XL_TYPE_ID = 193;

const mockRatewareXLBaseDetails: Record<number, RatewareXLBaseDetailData> = {
  1: {
    rateType: "Rateware XL",
    rateTypeId: RATEWARE_XL_TYPE_ID,
    name: "Standard Rates",
    description: "DYLT 2024/8/19, LB, USD",
    serviceLevel: ["LTL"],
    createdDate: "08/19/2024",
    createdBy: "Carlos Mendez",
    status: "Active",
    criteriaId: 1,
    numberOfGroups: 12,
    numberOfSequences: 5,
    configuration: {
      tariffName: "DYLT 11-17-2025",
      originType: "State",
      originValue: "USA",
      destinationType: "State",
      destinationValue: "Canada",
      direction: "One Way",
    },
  },
  11: {
    rateType: "Rateware XL",
    rateTypeId: RATEWARE_XL_TYPE_ID,
    name: "Express Freight",
    description: "DYLT 2024/9/01, LB, USD",
    serviceLevel: ["LTL"],
    createdDate: "09/01/2024",
    createdBy: "Maria Lopez",
    status: "Active",
    criteriaId: 11,
    numberOfGroups: 8,
    numberOfSequences: 3,
    configuration: {
      tariffName: "DYLT 09-01-2024",
      originType: "State",
      originValue: "TX",
      destinationType: "State",
      destinationValue: "CA",
      direction: "Both Ways",
    },
  },
  18: {
    rateType: "Rateware XL",
    rateTypeId: RATEWARE_XL_TYPE_ID,
    name: "Bulk Rates",
    description: "DYLT 2024/11/01, LB, USD",
    serviceLevel: ["LTL"],
    createdDate: "11/01/2024",
    createdBy: "David Kim",
    status: "Active",
    criteriaId: 18,
    numberOfGroups: 10,
    numberOfSequences: 4,
    configuration: {
      tariffName: "DYLT 11-01-2024",
      originType: "ZIP Code",
      originValue: "10001",
      destinationType: "ZIP Code",
      destinationValue: "90001",
      direction: "One Way",
    },
  },
  25: {
    rateType: "Rateware XL",
    rateTypeId: RATEWARE_XL_TYPE_ID,
    name: "Special Rates",
    description: "DYLT 2024/03/15, LB, USD",
    serviceLevel: ["LTL"],
    createdDate: "03/15/2024",
    createdBy: "Sarah Johnson",
    status: "Draft",
    criteriaId: 25,
    numberOfGroups: 6,
    numberOfSequences: 2,
    configuration: {
      tariffName: "DYLT 03-15-2024",
      originType: "State",
      originValue: "NY",
      destinationType: "State",
      destinationValue: "FL",
      direction: "One Way",
    },
  },
  32: {
    rateType: "Rateware XL",
    rateTypeId: RATEWARE_XL_TYPE_ID,
    name: "Freight Rates",
    description: "DYLT 2024/09/01, LB, USD",
    serviceLevel: ["LTL"],
    createdDate: "09/01/2024",
    createdBy: "Tom Wilson",
    status: "Active",
    criteriaId: 32,
    numberOfGroups: 14,
    numberOfSequences: 6,
    configuration: {
      tariffName: "DYLT 09-01-2024",
      originType: "State",
      originValue: "WA",
      destinationType: "State",
      destinationValue: "OR",
      direction: "Both Ways",
    },
  },
};

export const getRatewareXLBaseDetail = (
  id: number
): RatewareXLBaseDetailData | undefined => mockRatewareXLBaseDetails[id];
